import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { ResponsePayload, StaticPage } from "@/types";
import { fetchStaticPage } from "./thunk";

export interface StaticPageState {
  staticPage: Partial<StaticPage>;
  status: "idle" | "fetching" | "saving";
  error: string | null;
}

const initialState: StaticPageState = {
  staticPage: {},
  error: null,
  status: "idle"
};

export const staticPageSlice = createSlice({
  name: "staticPage",
  initialState,
  reducers: {
    clearStaticPage: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[staticPageSlice.name]
        };
      })
      .addCase(fetchStaticPage.pending, (state) => {
        state.status = "fetching";
        state.error = null;
      })
      .addCase(fetchStaticPage.fulfilled, (state, action) => {
        state.status = "idle";
        state.staticPage = action.payload ?? {};
      })
      .addCase(fetchStaticPage.rejected, (state, action) => {
        const { statusText } = (action.payload as ResponsePayload) || {};

        state.status = "idle";
        state.staticPage = {};
        state.error = statusText ?? action.error.message ?? null;
      });
  }
});

export const { clearStaticPage } = staticPageSlice.actions;
